
// src/pages/checagens/ChecagensListPage.tsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useChecagens, useFinalizarChecagem } from '../../hooks/useChecagens';
import { formatToSaoPaulo } from '../../utils/dates';
import Loading from '../../components/Loading';
import ErrorToast from '../../components/ErrorToast';
import ChecagemKPI from '../../components/checagens/ChecagemKPI';
import CriarChecagemModal from '../../components/checagens/CriarChecagemModal';
import AtribuirResponsavelModal from '../../components/checagens/AtribuirResponsavelModal';
import ConfirmDialog from '../../components/ConfirmDialog';
import './ChecagensListPage.css';

const ChecagensListPage: React.FC = () => {
  const navigate = useNavigate();
  const [filters] = useState({ responsavel: '', status: '' });
  const { data: checagens, isLoading, error } = useChecagens(filters);
  const [isCreateModalOpen, setCreateModalOpen] = useState(false);
  const [assignModalState, setAssignModalState] = useState<{ isOpen: boolean; checagemId: number | null }>({ isOpen: false, checagemId: null });
  const [finalizarModalState, setFinalizarModalState] = useState<{ isOpen: boolean; checagemId: number | null }>({ isOpen: false, checagemId: null });

  const finalizarChecagemMutation = useFinalizarChecagem();

  // Filtro pode ser conectado quando a UI for adicionada

  const openAssignModal = (checagemId: number) => {
    setAssignModalState({ isOpen: true, checagemId });
  };

  const closeAssignModal = () => {
    setAssignModalState({ isOpen: false, checagemId: null });
  };

  const openFinalizarModal = (checagemId: number) => {
    setFinalizarModalState({ isOpen: true, checagemId });
  };

  const closeFinalizarModal = () => {
    setFinalizarModalState({ isOpen: false, checagemId: null });
  };

  const handleFinalizar = () => {
    if (finalizarModalState.checagemId) {
      finalizarChecagemMutation.mutate(finalizarModalState.checagemId, {
        onSuccess: () => {
          closeFinalizarModal();
        }
      });
    }
  };

  if (isLoading) return <Loading />;
  if (error) return <ErrorToast message={error.message} onClose={() => {}} />;

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">Lista de Checagens</h1>
        <button onClick={() => setCreateModalOpen(true)} className="button">Nova Checagem</button>
      </div>

      {/* ... filter section ... */}

      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Nome/ID</th>
              <th>Responsável</th>
              <th>Progresso</th>
              <th>Última Atualização</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {checagens?.map(checagem => (
              <tr key={checagem.id}>
                <td>{checagem.nome || `Checagem #${checagem.id}`}</td>
                <td>
                  {checagem.responsavel_usuario_nome ? (
                    checagem.responsavel_usuario_nome
                  ) : (
                    <button onClick={() => openAssignModal(checagem.id)} className="button-link">Atribuir responsável</button>
                  )}
                </td>
                <td><ChecagemKPI checagemId={checagem.id} /></td>
                <td>{formatToSaoPaulo(checagem.updated_at!)}</td>
                <td className="actions-cell">
                  <button onClick={() => navigate(`/checagens/${checagem.id}`)} className="button button-work">Abrir</button>
                  {checagem?.status !== 'finalizada' && <button onClick={() => openFinalizarModal(checagem.id)} className="button">Finalizar</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {isCreateModalOpen && <CriarChecagemModal onClose={() => setCreateModalOpen(false)} />}
      {assignModalState.isOpen && (
        <AtribuirResponsavelModal 
          checagemId={assignModalState.checagemId!}
          onClose={closeAssignModal} 
        />
      )}
      {finalizarModalState.isOpen && (
        <ConfirmDialog 
          message="Tem certeza que deseja finalizar esta checagem?"
          onConfirm={handleFinalizar}
          onCancel={closeFinalizarModal}
        />
      )}
    </div>
  );
};

export default ChecagensListPage;
